import React, { useEffect, useState, useRef } from 'react';

function PdfViewerModal() {
  
  const [pdfUrl, setPdfUrl] = useState(null);
  const [pdfTitle, setPdfTitle] = useState('Relatório');
  const [scale, setScale] = useState(100);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const pdfBlobRef = useRef(null); // Guardar referência do blob para evitar garbage collection

  // Função para detectar se é Android
  const isAndroid = () => {
    return /android|webos|iphone|ipad|ipot|blackberry|iemobile|opera mini/i.test(
      navigator.userAgent.toLowerCase()
    );
  };

  // Função para imprimir diretamente
  const printDirectly = (url) => {
    const printWindow = window.open(url, '_blank');
    if (printWindow) {
      printWindow.onload = () => {
        printWindow.print();
        // Fecha a aba após 1 segundo da abertura da impressão
        setTimeout(() => {
          printWindow.close();
        }, 1000);
      };
    }
  };

  // Função para carregar dados do PDF
  const loadPdfData = () => {
    const pdfData = sessionStorage.getItem('pdfViewerData');

    if (pdfData) {
      try {
        const parsedData = JSON.parse(pdfData);
        const { url, title, pdfId } = parsedData;

        // Verificar se o blob ainda existe em pdfStorage
        if (pdfId && window.pdfStorage && window.pdfStorage[pdfId]) {
          // blob presente
        }

        setPdfUrl(url);
        setPdfTitle(title || 'Relatório');

        const isMobileDevice = isAndroid();
        setIsMobile(isMobileDevice);

        // Se for Android, vai direto para impressão
        if (isMobileDevice) {
          setTimeout(() => {
            printDirectly(url);
          }, 100);
        }
      } catch (error) {
        // erro ao recuperar dados do PDF
      }
    }
  };

  // Recuperar dados do sessionStorage quando o componente montar e monitorar mudanças
  useEffect(() => {
    
    
    let hasLoaded = false;

    const handleLoad = () => {
      if (!hasLoaded) {
        console.log('Iniciando carregamento do PDF na montagem...');
        hasLoaded = true;
        loadPdfData();
      }
    };

    // Tentar carregar dados ao montar
    handleLoad();

    // Listener para evento customizado disparado pelo utils/relatoriosGlobais
    const handlePdfUpdate = (event) => {
      hasLoaded = false;
      loadPdfData();
    };

    window.addEventListener('pdfViewerUpdate', handlePdfUpdate, true); // capture phase
    
    // Também tentar carregar a cada 200ms durante 5 segundos (fallback robusto)
    const fallbackInterval = setInterval(() => {
      loadPdfData();
    }, 200);
    
    const timeoutHandle = setTimeout(() => {
      console.log('Parando fallback após 5 segundos');
      clearInterval(fallbackInterval);
    }, 5000);

    return () => {
      
      window.removeEventListener('pdfViewerUpdate', handlePdfUpdate, true);
      clearInterval(fallbackInterval);
      clearTimeout(timeoutHandle);
    };
  }, []);

  const handleDownload = () => {
    if (pdfUrl) {
      const link = document.createElement('a');
      link.href = pdfUrl;
      link.download = `${pdfTitle || 'relatorio'}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const handlePrint = () => {
    if (pdfUrl) {
      const printWindow = window.open(pdfUrl);
      if (printWindow) {
        printWindow.print();
      }
    }
  };

  const handleClose = () => {
    // Limpar URL do blob
    if (pdfUrl) {
      URL.revokeObjectURL(pdfUrl);
    }
    // Limpar referência do blob
    pdfBlobRef.current = null;
    
    sessionStorage.removeItem('pdfViewerData');
    setPdfUrl(null);
    setPdfTitle('Relatório');
  };

  if (!pdfUrl) {
    return null;
  }

  // Em Android, o modal não é renderizado (já vai direto para impressão)
  if (isMobile) {
    return null;
  }
  

  // Comportamento normal para Desktop (iframe)
  return (
    <>
      <style>{`.pdf-viewer-modal-content { border-bottom-left-radius: 10px !important; border-bottom-right-radius: 10px !important; overflow: hidden !important; }`}</style>
      <div
      className="modal fade show d-block"
      tabIndex="-1"
      style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
    >
      <div className="modal-dialog modal-lg" style={{ maxWidth: '95vw', height: '90vh' }}>
        <div className="modal-content h-100 pdf-viewer-modal-content">
          {/* Header (padronizado com modalService / DefaultModal) */}
          <div className="modal-header text-white py-1" style={{ background: 'linear-gradient(90deg, #0b3383, #0e48ad)' }}>
            <h6 className="modal-title text-center m-0">
              <i className="bi bi-file-earmark-pdf me-2"></i>
              {pdfTitle || 'Visualizador de Relatório'}
            </h6>
            <button
              className="btn btn-link text-white p-0 mb-0"
              onClick={handleClose}
              title="Fechar"
              style={{ fontSize: '0.9rem', textDecoration: 'none' }}
            >
              <i className="bi bi-x-lg"></i>
            </button>
          </div>

          {/* Body com PDF */}
          <div className="modal-body p-0 pdf-viewer-container" style={{ flex: 1, overflow: 'hidden' }}>
            <iframe
              key={pdfUrl}
              src={pdfUrl}
              style={{
                width: '100%',
                height: '100%',
                border: 'none',
              }}
              title="PDF Viewer"
              onLoad={() => console.log('iframe carregado com sucesso')}
              onError={() => console.error('Erro ao carregar iframe')}
            />
          </div>
        </div>
      </div>
    </div>
    </>
  );
}

export default PdfViewerModal;
